import ApiData from '@/api/class/ApiData'
import { responseType } from 'complex-require/src/Rule'

export type vehicleRealTimeType = {
  vin: string // VIN
  agreement: string // 协议
  onlineState: number // 在线状态
  gatime: string
  tmiles: number // 总里程
  lockDesc: string // 锁状态
  position: string // 位置
}

export type vehicleRealTimeResType = responseType<{
  data: vehicleRealTimeType
}>

const vehicleApi = {
  vehicleRealTime: new ApiData<[{
    vin: string
  }], vehicleRealTimeResType>({
    name: '车辆实时信息',
    url: 'vehicle/get/vehicle/infoAndRealtimeCS',
    urlConfig: {
      pre: '',
      service: 'vehicle/info/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleTerminalStatus: new ApiData<[{
    vin: string
    protocolType: string
    colList: string[]
  }], responseType>({
    name: '车辆终端状态',
    url: 'data/real/by/vin/type',
    urlConfig: {
      pre: '',
      service: 'vehicle/data/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleSupportLock: new ApiData<[{
    vin: string
  }], responseType>({
    name: '车辆是否支持锁车',
    url: 'web/ufoleasing/getLockedFlag',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleLockLog: new ApiData<[{
    vin: string
    agreement: string
    issueFrom: string
    pageSize: number
    pageNo: number
  }], responseType>({
    name: '锁车记录',
    url: 'vehicle_control_record/get_vehicle_control_record_list',
    urlConfig: {
      pre: '',
      service: 'vehicle/control/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleControlIssue: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆控制下发',
    url: 'terminal_command_ter/issue_terminal_control_commands',
    urlConfig: {
      pre: '',
      service: 'vehicle/control/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleControlSync: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆控制下发状态获取',
    url: 'vehicle_control_status_record/get_locked_state',
    urlConfig: {
      pre: '',
      service: 'vehicle/control/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleList: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆明细列表',
    url: 'web/cs-overdue-record/vehiclePageList',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehiclePreservation: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆保全申请列表',
    url: 'web/cs-apply-record-keep/pageList',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehiclePreservationInfo: new ApiData<[{ id: string }], responseType>({
    name: '车辆保全申请详情',
    url: 'web/cs-apply-record-keep/detail',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehiclePreservationInfoByOverdueId: new ApiData<[{ overdueRecordId: string, applyStatus?: string }], responseType>({
    name: '车辆保全申请详情',
    url: 'web/cs-apply-record-keep/detailByOverId',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehiclePreservationCostDetail: new ApiData<[{ applyRecordKeepId: string }], responseType>({
    name: '车辆保全费用明细',
    url: 'web/cs-apply-record-cost-detail/list',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehiclePreservationBuild: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆保全申请新增',
    url: 'web/cs-apply-record-keep/apply',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehiclePreservationChange: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆保全申请修改',
    url: 'web/cs-apply-record-keep/submit',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehiclePreservationReject: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆保全申请驳回',
    url: 'web/cs-apply-record-keep/reject',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleAmount: new ApiData<[{
    type: string
    overdueRecordId: string
  }], responseType>({
    name: '获取处置/赎回相关逾期金额',
    url: 'web/ufoleasing/getCzShFlowAmount',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleRedeem: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆赎回申请列表',
    url: 'web/cs-apply-record-redemption/pageList',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleRedeemInfo: new ApiData<[{ id: string }], responseType>({
    name: '车辆赎回申请详情',
    url: 'web/cs-apply-record-redemption/detail',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleRedeemBuild: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆赎回申请新增',
    url: 'web/cs-apply-record-redemption/apply',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleRedeemChange: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆赎回申请修改',
    url: 'web/cs-apply-record-redemption/submit',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleRedeemReject: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆赎回申请驳回',
    url: 'web/cs-apply-record-redemption/reject',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleRedeemSettle: new ApiData<[{
    id: string
  }], responseType>({
    name: '车辆赎回结清',
    url: 'web/cs-apply-record-redemption/initEarlySettlement',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleDispose: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆处置申请列表',
    url: 'web/cs-apply-record-handle/pageList',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleDisposeInfo: new ApiData<[{ id: string }], responseType>({
    name: '车辆处置申请详情',
    url: 'web/cs-apply-record-handle/detail',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleDisposeInfoByOverdueId: new ApiData<[{ overdueRecordId: string, applyStatus: string }], responseType>({
    name: '车辆处置申请详情:基于逾期记录ID',
    url: 'web/cs-apply-record-handle/detailByOverId',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'get',
    data: ['inherit']
  }),
  vehicleDisposeBuild: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆处置申请新增',
    url: 'web/cs-apply-record-handle/apply',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleDisposeChange: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆处置申请修改',
    url: 'web/cs-apply-record-handle/submit',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleDisposeReject: new ApiData<[Record<string, unknown>], responseType>({
    name: '车辆处置申请驳回',
    url: 'web/cs-apply-record-handle/reject',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
  vehicleDisposeSettle: new ApiData<[{
    id: string
  }], responseType>({
    name: '车辆处置结清',
    url: 'web/cs-apply-record-handle/initEarlySettlement',
    urlConfig: {
      pre: '',
      service: 'ufo/cs/'
    },
    method: 'post',
    data: ['inherit']
  }),
}

export default vehicleApi
